import { ListenerAudioBrowseParams } from '../../../hooks/useListenerAudio';
import { ResourceBrowseParams } from '../../../hooks/useResources';
import type { SharedFilterValues } from '../hooks/useContentLibraryUrlState';

const buildExperienceParams = (
  experienceType: 'audio' | 'video',
  page: number,
  search: string,
  sharedFilters: SharedFilterValues,
  pageLimit: number,
  showTestUsers: boolean,
): ListenerAudioBrowseParams => ({
  page,
  limit: pageLimit,
  experience_type: experienceType,
  search: search || undefined,
  admin_override: true,
  tag_groups: sharedFilters.tagGroupIds.length > 0 ? sharedFilters.tagGroupIds : undefined,
  tag_ids: sharedFilters.tagIds.length > 0 ? sharedFilters.tagIds : undefined,
  domain_id: sharedFilters.domainId ?? undefined,
  hide_incomplete_peers: true,
  hide_test_users: !showTestUsers,
  grade: 'approved',
  order_by: 'created_at',
  order_direction: 'desc',
});

export const buildAudioParams = (
  page: number,
  search: string,
  sharedFilters: SharedFilterValues,
  pageLimit: number,
  showTestUsers: boolean,
): ListenerAudioBrowseParams => buildExperienceParams('audio', page, search, sharedFilters, pageLimit, showTestUsers);

export const buildVideoParams = (
  page: number,
  search: string,
  sharedFilters: SharedFilterValues,
  pageLimit: number,
  showTestUsers: boolean,
): ListenerAudioBrowseParams => buildExperienceParams('video', page, search, sharedFilters, pageLimit, showTestUsers);

export const buildResourcesParams = (
  page: number,
  search: string,
  sharedFilters: SharedFilterValues,
  pageLimit: number,
  statuses: ('live' | 'hidden')[],
): ResourceBrowseParams => ({
  page,
  limit: pageLimit,
  search: search || undefined,
  admin_override: true,
  tag_groups: sharedFilters.tagGroupIds.length > 0 ? sharedFilters.tagGroupIds : undefined,
  tag_ids: sharedFilters.tagIds.length > 0 ? sharedFilters.tagIds : undefined,
  domain_id: sharedFilters.domainId ?? undefined,
  client_id: sharedFilters.clientId ?? undefined,
  status: statuses.length ? statuses : undefined,
  enabled_for_domain_ids: sharedFilters.domainId ? [sharedFilters.domainId] : undefined,
});
